import React from 'react';
import styled from 'styled-components';
import { AddPrefixToObject } from '../../models/utilTypes';

const tryAppendUnit = (attr?: number | string): string | number | undefined => {
  if (typeof attr === 'string' || attr === 0) return attr;
  else if (typeof attr === 'number') return `${attr}px`;
  return;
};

export const getSizeStyles = (
  size?: number | string,
  maxSize?: number | string,
  width?: number | string,
  maxWidth?: number | string,
  height?: number | string,
  maxHeight?: number | string
) => {
  const calculatedWidth = tryAppendUnit(width ?? size);
  const calculatedMaxWidth = tryAppendUnit(maxWidth ?? maxSize);
  const calculatedHeight = tryAppendUnit(height ?? size);
  const calculatedMaxHeight = tryAppendUnit(maxHeight ?? maxSize);

  return `
    ${calculatedWidth ? `width: ${calculatedWidth};` : ''}
    ${calculatedHeight ? `height: ${calculatedHeight};` : ''}
    ${calculatedMaxWidth ? `max-width: ${calculatedMaxWidth};` : ''}
    ${calculatedMaxHeight ? `max-height: ${calculatedMaxHeight};` : ''}
  `;
};

interface IStyledImgProps {
  size?: number | string;
  maxSize?: number | string;
  height?: number | string;
  maxHeight?: number | string;
  width?: number | string;
  maxWidth?: number | string;
  borderRadius?: string | 0;
  margin?: string | 0;
}

type IPrefixedStyledImgProps = AddPrefixToObject<IStyledImgProps, '$'>;

const StyledImg = styled.img<IPrefixedStyledImgProps>`
  display: block;
  border-radius: ${props => props.$borderRadius ?? 0};

  ${({ $margin }) =>
    typeof $margin === 'undefined' ? '' : `margin: ${$margin};`}

  ${({ $size, $maxSize, $width, $maxWidth, $height, $maxHeight }) =>
    getSizeStyles($size, $maxSize, $width, $maxWidth, $height, $maxHeight)};
`;

interface IPhotoPropsBase {
  src?: string;
  alt: string;
  fallback?: any;
  className?: string;
  isLazyLoaded?: boolean;
}

export interface IPhotoProps
  extends Partial<
      Omit<
        Omit<React.HTMLProps<HTMLImageElement>, keyof IStyledImgProps>,
        keyof IPhotoPropsBase
      >
    >,
    IPhotoPropsBase,
    IStyledImgProps {}

const Photo: React.FC<IPhotoProps> = ({
  src,
  alt,
  fallback,
  size,
  maxSize,
  width,
  maxWidth,
  height,
  maxHeight,
  borderRadius,
  margin,
  isLazyLoaded = true,
  ...props
}) => {
  if (!src) {
    return fallback ? fallback : null;
  }

  return (
    // @ts-ignore
    <StyledImg
      src={src}
      alt={alt}
      loading={isLazyLoaded ? 'lazy' : 'eager'}
      $borderRadius={borderRadius}
      $size={size}
      $maxSize={maxSize}
      $width={width}
      $maxWidth={maxWidth}
      $height={height}
      $maxHeight={maxHeight}
      $margin={margin}
      {...props}
    />
  );
};

export default Photo;
